// extracted by mini-css-extract-plugin
module.exports = {"report_title":"reportViewModal_report_title_1pkta","modal_footer":"reportViewModal_modal_footer_3GhBB"};